import { provide, inject, type InjectionKey } from 'vue'
import letterOccupationOptions from '@/utils/format-edit/letterOccupationOptions.json'

export type LetterFormatData = {
  createDate: Date | null
  writeDate?: string
  introSummary: string
  entrySummary: string
  resumeSummary: string
  occupation: string
  company_name: string
  staff_name: string
  jobSummary: string
  experienceAndKnowledge: string
  skillsToUse: unknown[]
  jobHistories: unknown[]
  licenseHistories: unknown[]
  prMessage: string
} & Record<string, unknown>

/** 例文 type フィルタ用（カード UI は出さない） */
export { letterOccupationOptions }

export const LETTER_DEFAULT_OCCUPATION =
  letterOccupationOptions.find((o) => o.value === 'others')?.value ?? 'others'

const LETTER_FORMAT_DATA_KEY: InjectionKey<LetterFormatData> =
  Symbol('letterFormatData')

export function provideLetterFormatData(formatData: LetterFormatData) {
  provide(LETTER_FORMAT_DATA_KEY, formatData)
}

export function useLetterFormatData(): LetterFormatData {
  const formatData = inject(LETTER_FORMAT_DATA_KEY)
  if (!formatData) {
    throw new Error('useLetterFormatData() must be used under LetterEdit')
  }
  return formatData
}

export function createEmptyLetterFormatData(): LetterFormatData {
  return {
    createDate: null,
    introSummary: '',
    entrySummary: '',
    resumeSummary: '',
    occupation: LETTER_DEFAULT_OCCUPATION,
    company_name: '',
    staff_name: '',
    jobSummary: '',
    experienceAndKnowledge: '',
    skillsToUse: [],
    jobHistories: [],
    licenseHistories: [],
    prMessage: ''
  }
}
